import React, { FC } from 'react';
import Toast from 'antd-mobile/es/components/toast';
import { Image } from '../Image';
import styles from './MediaCard.module.scss';

const isDaXiang = (ua: string) => {
  return (
    /xm\/\d{1,2}.\d{1,2}.\d{1,2}/.test(ua) ||
    ua.indexOf('com.meituan.message') > -1 ||
    ua.indexOf('com.meituan.xm') > -1 ||
    ua.indexOf('com.sankuai.xmpp') > -1
  );
};

interface Props {
  MediaCardData: {
    icon: string;
    title: string;
    formatTip: string;
    downBtnText: string;
    downBtnURL?: string;
  };
}
const MediaCard: FC<Props> = (props) => {
  const { MediaCardData } = props;
  const { icon, title, formatTip, downBtnText, downBtnURL } = MediaCardData;

  const downUrl = () => {
    if (isDaXiang(navigator.userAgent)) {
      Toast.show('大象移动端不支持下载zip文件，请在其他浏览器或者电脑端完成下载。');
    } else {
      window.location.href = downBtnURL as string;
    }
  };

  return (
    <>
      <div className={styles['media-card-box']}>
        <div className={styles['card-img-box']}>
          <div className={styles['img-wrap']}>
            <Image objectFit="contain" src={icon} layout="fill" />
          </div>
        </div>
        <div className={styles['media-down-box']}>
          <div>
            <div className={styles['down-title']}>{title}</div>
            <p className={styles['format-tip']}>{formatTip}</p>
          </div>
          <div className={styles.downBtns}>
            <a className={styles['down-btn']} onClick={downUrl} target="downloadFile">
              {downBtnText}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
MediaCard.defaultProps = {
  MediaCardData: {
    icon: 'https://p0.meituan.net/smartvenus/7381c02638c2835d87acbfb8a64112059292.png',
    title: '美团标准横版',
    formatTip: 'AI格式/PNG格式',
    downBtnText: '下载',
    downBtnURL: '',
  },
};

MediaCard.displayName = 'MediaCard';
export default MediaCard;
